import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";
import LoadingOverlay from "react-loading-overlay";
import { toast } from "react-toastify";
import apiURL from "../../config/api.json";
import axios from "axios";
import { Button } from "@material-ui/core";
import { setInStorage } from "../../utils/storage.js";
//import ReactExport from "react-export-excel";
import { getImage } from "./Images";
import { CloudDownload } from "@material-ui/icons";

//const ExcelFile = ReactExport.ExcelFile;
//const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
//const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class ListB extends Component {
  state = {
    data: {
      columns: [
        {
          label: "Diagnostic Center Name",
          field: "diagnostic_center_name",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Patient ID",
          field: "pid",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Name",
          field: "name",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Age",
          field: "age",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Organ",
          field: "examined_organ",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Upload Date",
          field: "uploaded_date",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Report Date",
          field: "reporting_date",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Status",
          field: "status",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Doctors Assigned",
          field: "assigned_to",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Action",
          field: "action",
          sort: "asc",
          width: "auto",
        }
      ],
      rows: []
    },
    image: "",
    isActive: false,
    base64: ""
  };

  changeIsActive = isActive => {
    this.setState({ isActive });
  };

  //Initialization of data
  intializationOfData = () => {
    let newDataRows = [];
    this.props.listViewArr.forEach((item, i) => {
      const upload_date =
        typeof item.upload_date === "string" &&
        item.upload_date.substring(0, 4) +
          "." +
          item.upload_date.substring(4, 6) +
          "." +
          item.upload_date.substring(6, 8) +
          " " +
          item.upload_date.substring(8, 10) +
          ":" +
          item.upload_date.substring(10, 12);

      const report_date =
        typeof item.report_date === "string" &&
        item.report_date.substring(0, 4) +
          "." +
          item.report_date.substring(4, 6) +
          "." +
          item.report_date.substring(6, 8) +
          " " +
          item.report_date.substring(8, 10) +
          ":" +
          item.report_date.substring(10, 12);
      newDataRows.push({
        diagnostic_center_name: item.institution,
        report_id: item.report_id,
        pid: item.pid,
        name: item.name,
        age: item.age,
        examined_organ:( 
        <span className={item.priority === 1 ? "colorChange" : ""}>
            {item.body_parts}
        </span>
        ),
        assigned_to: item.assigned_to,
        uploaded_date:
          typeof item.upload_date === "string" &&
          item.upload_date.substring(6, 8) +
            "/" +
            item.upload_date.substring(4, 6) +
            "/" +
            item.upload_date.substring(0, 4) +
            ", " +
            item.upload_date.substring(8, 10) +
            ":" +
            item.upload_date.substring(10, 12) +
            ":" +
            item.upload_date.substring(12, 14),
        reporting_date:
          typeof item.report_date === "string" &&
          item.report_date.substring(6, 8) +
            "/" +
            item.report_date.substring(4, 6) +
            "/" +
            item.report_date.substring(0, 4) +
            ", " +
            item.report_date.substring(8, 10) +
            ":" +
            item.report_date.substring(10, 12) +
            ":" +
            item.report_date.substring(12, 14),
        status: (
          <span
            style={{
              color:
                item.status === 0
                  ? "red"
                  : item.status === 2
                  ? "green"
                  : "yellow",
              fontWeight: "bold"
            }}
          >
            {item.status === 0
              ? "Pending"
              : item.status === 2
              ? "Completed"
              : "In-View"}
          </span>
        ),
        action: (
          <Button
            style={{
              textTransform: "none",
              fontWeight: "bold"
            }}
            variant="outlined"
            color="secondary"
            size="small"
            onClick={() =>
              this.setState({ isActive: true }, () => {
                this.fetchImageData(
                  item.report_id,
                  item.report_id +
                    "--" +
                    item.pid +
                    "--" +
                    item.name +
                    "--" +
                    item.age +
                    "--" +
                    item.gender +
                    "--" +
                    upload_date +
                    "--" +
                    report_date,
                  "view"
                );
              })
            }
          >
            View
          </Button>
        ),
      //   edit_case:(      
      //     <Button
      //       variant="outlined"
      //       color="primary"
      //       style={{ textTransform: "none", marginTop: "10px" }}
      //       size="small"
      //       onClick={() => {
      //         console.log(item)
      //         this.setState({ isActive: true }, () => {
      //           setInStorage("edit_case",[0, item.report_id,item.assigned_to, item.body_parts])
      //           this.fetchImageData(
      //             item.report_id,
      //             item.report_id +
      //               "--" +
      //               item.pid +
      //               "--" +
      //               item.name +
      //               "--" +
      //               item.age +
      //               "--" +
      //               item.gender +
      //               "--" +
      //               upload_date +
      //               "--" +
      //               report_date,
      //               "edit"
      //           );
                
      //         })
             
      //     }}
      //     >
      //       Edit
      //     </Button>
      // )
      });
    });

    this.setState({
      data: { columns: this.state.data.columns, rows: newDataRows }
    });
  };

  //Fetch view image using POST request
  fetchImageData = (case_id, data, option) => {
    axios
      .post(
        apiURL.postMethodURL,
        {
          task: "downloadImageFiles",
          case_id: case_id.toString(),
          numImage: "1"
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(res => {
        this.setState({ img: res.data.records[0][0].img0 }, () => {
          this.changeIsActive(false);
          this.fetchDocData(case_id, data, option);
        });
      })
      .catch(err => {
        this.notifyError(err.toString());
      });
  };

  //Fetch doc data using POST request
  fetchDocData = (report_id, data, option) => {
    axios
      .post(
        apiURL.postMethodURL,
        {
          task: "getWordFilePrintInfo",
          report_id: report_id.toString()
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(res => {
        getImage(res.data[0].assigned_to).then(
          (response) => {
             this.setState({base64: `data:image/png;base64,${response}`},
              () => { 
                setInStorage("name",  res.data[0].name)
                if (typeof res.data[0].report === "string") {
                  axios
                    .post(
                      apiURL.docApi,
                      {
                        pid: res.data[0].pid,
                        report: res.data[0].report,
                        name: res.data[0].name,
                        age: res.data[0].age,
                        gender: res.data[0].gender,
                        upload_date: res.data[0].upload_date,
                        report_date: res.data[0].report_date,
                        body_parts: res.data[0].body_parts,
                        referrer: res.data[0].referrer,
                        isPdf: false,
                        image: this.state.base64
                      },
                      {
                        headers: { "Content-Type": "application/json" }
                      }
                    )
                    .then(res => {
                      this.setState({ isActive: false }, () => {
                        this.intializationOfData();
                        setInStorage("View", {
                          image: this.state.img,
                          case_id: report_id,
                          data,
                          html: res.data.html
                        });
                        if(option !== "edit"){
                          window.open("/#/View");
                        } else {
                          window.open("/#/EditCase")
                        }
                      });
                    })
                    .catch(err => {
                      this.setState({ isActive: false });
                      this.notifyError(err.toString());
                    });
                } else {
                  this.setState({ isActive: false });
                  if(option === "edit"){
                    window.open("/#/EditCase")
                  } else {
                    window.open("/#/View");
                  }
                }
              }
                
            )
          }
        )
        .catch(
            (error) => {
                console.log(error);
            }
        )
      })
      .catch(err => {
        this.setState({ isFetchedList: true, isActive: false });
        this.notifyError(err.toString());
        if(option === "edit"){
          window.open("/#/EditCase")
        }
      });
  };

  //Error notification
  notifyError = error => {
    toast.error("" + error.toString());
  };

  //This function will run first
  componentDidMount() {
    this.intializationOfData();
  }

  render() {
    
    const { data } = this.state;
    
    return (
      <LoadingOverlay
        active={this.state.isActive}
        spinner
        text="Loading, Please Wait..."
      >
	{/*
        <ExcelFile element={
            <Button variant="outlined" color="primary" size="small" style={{textTransform:"none", zIndex: 1, color: "white", backgroundColor: "green", position: "absolute", marginLeft: "-90px", marginTop: "5px"}}>
              <CloudDownload/> <span style={{marginLeft: "5px"}}>Export To Excel</span>
            </Button>}>
            <ExcelSheet data={this.props.listViewArr} name="List">
                <ExcelColumn label="Diagnostic Center Name" value="institution"/>
                <ExcelColumn label="Patient ID" value="pid"/>
                <ExcelColumn label="Name" value="name"/>
                <ExcelColumn label="Age" value="age"/>
                <ExcelColumn label="Organ" value="body_parts"/>
                <ExcelColumn label="Upload Date" value={(col) => typeof col.upload_date === "boolean"
                                                            ? ""
                                                            : col.upload_date}
                />
                <ExcelColumn label="Report Date" value={(col) => typeof col.report_date === "boolean"
                                                            ? ""
                                                            : col.report_date}
                />
                <ExcelColumn label="Status" value={(col) => col.status === 0
                                                            ? "Pending"
                                                            : col.status === 2
                                                            ? "Completed"
                                                            : "In-View"}
                />
                <ExcelColumn label="Doctors Assigned" value="assigned_to"/>
            </ExcelSheet>
          </ExcelFile> */}
        <MDBDataTable
          id="table-to-xls"
          striped
          responsiveXl
          bordered
          small
          entries={100}
          pagesAmount={5}
          data={data}
          noBottomColumns
          hover
          style={{ background: "white" }}
        />
      </LoadingOverlay>
    );
  }
}

export default ListB;
